<template>
  <v-card class="mb-4 pa-4" outlined>
    <!-- Shop Name Header -->
    <div class="d-flex align-center mb-3">
      <v-checkbox :input-value="isAllSelected" @change="toggleShopSelection" hide-details class="mt-0 pt-0 mr-2"
        color="primary"></v-checkbox>
      <div class="font-weight-bold subtitle-1">
        <v-icon small left>mdi-store</v-icon>
        {{ group.shopName }}
      </div>
    </div>
    <v-divider class="mb-4"></v-divider>

    <!-- Items -->
    <div v-for="(item, i) in group.items" :key="item.id">
      <CartItem :item="item" :selected="selectedIds.includes(item.id)" :last-item="i === group.items.length - 1"
        @toggle-select="$emit('toggle-select', $event)" @update-qty="(itm, val) => $emit('update-qty', itm, val)"
        @set-qty="(itm, val) => $emit('set-qty', itm, val)"
        @remove="$emit('remove', $event)" />
    </div>
  </v-card>
</template>

<script>
import CartItem from "./CartItem.vue";

export default {
  name: "CartShopGroup",
  components: {
    CartItem,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isAllSelected() {
      return this.group.items.every((item) => this.selectedIds.includes(item.id));
    },
  },
  methods: {
    toggleShopSelection(val) {
      this.$emit("toggle-shop-select", {
        items: this.group.items,
        selected: val,
      });
    },
  },
};
</script>
